export default {
  title: 'Date bancare',
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    success: 'Informațiile au fost salvate cu succes.',
  },
};
